import { render, staticRenderFns } from "./ContactCurrentGroupHeader.vue?vue&type=template&id=a5c79b3e"
import script from "./ContactCurrentGroupHeader.vue?vue&type=script&lang=js"
export * from "./ContactCurrentGroupHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports